import {
  GridToolbarQuickFilter,
  GridToolbarQuickFilterProps,
} from '@mui/x-data-grid-pro';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

import { useURLFilters } from 'hooks/useURLFilters';

import { FilterIds } from '../FilterPanel';

interface Props {
  useCustomFilterModel: boolean;
}

const SearchInput = ({ useCustomFilterModel }: Props) => {
  const { filters, updateFilterModelItems } = useURLFilters();
  const nameFilter = filters.find((filter) => filter.field === FilterIds.NAME);
  const [quickFilterText, setQuickFilterText] = useState(
    nameFilter?.value ?? ''
  );

  useEffect(() => {
    setQuickFilterText(nameFilter?.value ?? '');
  }, [nameFilter]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSetParams = useCallback(
    debounce((value: string) => {
      updateFilterModelItems({ [FilterIds.NAME]: value });
    }, 500),
    []
  );

  const handleQuickFilterChange = (value: string) => {
    setQuickFilterText(value);

    debouncedSetParams(value);
  };

  const controlledInputProps: Partial<GridToolbarQuickFilterProps> = {
    onChange: (event) => {
      handleQuickFilterChange(event.target.value);
    },
    value: quickFilterText,
  };

  return (
    <GridToolbarQuickFilter
      variant="outlined"
      size="small"
      {...(useCustomFilterModel ? controlledInputProps : {})}
    />
  );
};

export default SearchInput;
